import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpRequest, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '..';
import { BaseService } from './base.service';
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ExportImportService extends BaseService {

    constructor(protected http: HttpClient, protected authenticationService: AuthenticationService) {
        super(http, authenticationService, 'exports-imports');
    }

    getAllWithType(subtype: string) {
        return this.http.get<any>(`${environment.apiUrl}` + '/admin/' + this.type + '/' + subtype);
    }

    generateExport(record: any) {
        return this.http.post<any>(`${environment.apiUrl}` + '/admin/' + this.type + '/generate-export', record);
    }

    generateImport(record: any) {
        return this.http.post<any>(`${environment.apiUrl}` + '/admin/' + this.type + '/generate-import', record);
    }

    uploadFile(file: File, reporturl: string): Observable<HttpEvent<any>> {
        let formData = new FormData();
        formData.append('upload', file);

        let params = new HttpParams();

        const options = {
            params: params,
            reportProgress: true,
        };
        let req;
        if (reporturl == 'page-import')
            req = new HttpRequest('POST', `${environment.apiUrl}` + '/admin/' + this.type + '/fileupload-page-import', formData, options);
        else
            req = new HttpRequest('POST', `${environment.apiUrl}` + '/admin/' + this.type + '/fileupload', formData, options);
        console.log('req', req);
        return this.http.request(req);
    }

    sendCommand(record: any) {
        if (this.currentUser) {
            return this.http.post<any>(`${environment.apiUrl}` + '/admin/' + this.type + '/send-command', record);
        }
    }

}